import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Core2Config } from "../../shared";
import { CommissionSchemeContainerModel } from "../../../../../../models/aggregates/erp/commission-scheme";
import { BaseApiPublicLoginTemplateService } from "../../shared/base-api-public-login-template.service";

@Injectable({ providedIn: 'root' })
export class CommissionSchemeService extends BaseApiPublicLoginTemplateService<CommissionSchemeContainerModel, CommissionSchemeContainerModel, CommissionSchemeContainerModel> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.COMMISSION_PREFIX + 'commission-scheme';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.COMMISSION_PREFIX + 'commission-scheme';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.COMMISSION_PREFIX + 'commission-scheme';
        this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.COMMISSION_PREFIX + 'commission-scheme/' + BaseApiPublicLoginTemplateService.LOGIN_EP;
        this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.COMMISSION_PREFIX + 'commission-scheme/' + BaseApiPublicLoginTemplateService.PUBLIC_EP;
        this.httpClient = http;
    }
}